/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'access-point': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M4.93 4.93A9.969 9.969 0 002 12c0 2.76 1.12 5.26 2.93 7.07l1.41-1.41A7.938 7.938 0 014 12c0-2.21.89-4.22 2.34-5.66L4.93 4.93m14.14 0l-1.41 1.41A7.955 7.955 0 0120 12c0 2.22-.89 4.22-2.34 5.66l1.41 1.41A9.969 9.969 0 0022 12c0-2.76-1.12-5.26-2.93-7.07M7.76 7.76A5.98 5.98 0 006 12c0 1.65.67 3.15 1.76 4.24l1.41-1.41A3.99 3.99 0 018 12c0-1.11.45-2.11 1.17-2.83L7.76 7.76m8.48 0l-1.41 1.41A3.99 3.99 0 0116 12c0 1.11-.45 2.11-1.17 2.83l1.41 1.41A5.98 5.98 0 0018 12c0-1.65-.67-3.15-1.76-4.24M12 10a2 2 0 00-2 2 2 2 0 002 2 2 2 0 002-2 2 2 0 00-2-2z"/>'
  }
})
